export class StringUtil {
    
    public static startWith (origin : string, compare : string) : boolean {
        var isIndexOf = (origin.indexOf(compare) == 0);
        return isIndexOf;
    }
}


// WEBPACK FOOTER //
// ./src/app/utility/StringUtil.ts